@if (bankList) {
  <p-select
    (onChange)="onBankChange($event)"
    [options]="bankList"
    [(ngModel)]="bank"
    [placeholder]="bank"
    [filter]="true"
    filterBy="label, value"
  >
  </p-select>
}
